// Libraries
import React from 'react';

// Supermove
import {ScrollView, Styled} from '@supermove/components';
import {gql} from '@supermove/graphql';
import {useResponsive, Form} from '@supermove/hooks';
import {LocationModel, OrganizationModel} from '@supermove/models';
import {colors} from '@supermove/styles';

// App
import Button from '@shared/design/components/Button';
import Line from '@shared/design/components/Line';
import {JobMap} from 'modules/Job/components';
import JobFields from 'modules/Job/components/JobFields';
import ProjectFieldsForJob from 'modules/Project/components/ProjectFieldsForJob';

const Section = Styled.View<{index: number}>`
  z-index: ${({index = 0}) => 100 - index};
`;

const ExtraSpace = Styled.View`
  height: 200px;
`;

const Footer = Styled.View`
  padding: 8px;
  background-color: ${colors.white};
`;

const NewProjectPageV2Fields = ({
  form,
  scrollViewRef,
  mapRef,
  organizationSelectedForCreateProject,
  submitting,
  canEditProjectOrganization,
  isEnabledGooglePlacesCenterLocation,
  warehouseLocation,
  moveLocations,
  boundLocations,
  handleSubmit,
  handleShowSalesCalendar,
}: {
  form: Form;
  scrollViewRef: React.MutableRefObject<undefined>;
  mapRef: React.MutableRefObject<undefined>;
  organizationSelectedForCreateProject: OrganizationModel;
  submitting: boolean;
  canEditProjectOrganization: boolean;
  isEnabledGooglePlacesCenterLocation: boolean;
  warehouseLocation: LocationModel | null;
  moveLocations: LocationModel[];
  boundLocations: LocationModel[];
  handleSubmit: () => void;
  handleShowSalesCalendar?: () => void;
}) => {
  const responsive = useResponsive();

  return (
    <React.Fragment>
      <ScrollView ref={scrollViewRef} style={{flex: 1}}>
        <Section index={1}>
          <ProjectFieldsForJob
            field={'projectForm'}
            form={form}
            organization={organizationSelectedForCreateProject}
            disabled={submitting}
            shouldResetJobDateOnProjectTypeChange
            jobFormField={'projectForm.jobForms.0'}
            canEditProjectOrganization={canEditProjectOrganization}
          />
        </Section>
        <Section index={2}>
          <JobFields
            field={'projectForm'}
            form={form}
            organization={organizationSelectedForCreateProject}
            jobIndex={0}
            shouldResetJobDateOnJobTypeChange
            jobFormField={'projectForm.jobForms.0'}
            warehouseLocation={isEnabledGooglePlacesCenterLocation ? warehouseLocation : null}
            mapRef={mapRef}
            jobMapComponent={
              <JobMap
                locations={moveLocations}
                boundLocations={boundLocations}
                warehouseLocation={warehouseLocation}
                mapRef={mapRef}
              />
            }
            handleShowSalesCalendar={handleShowSalesCalendar}
          />
        </Section>
        <ExtraSpace />
      </ScrollView>
      <Line />
      <Footer {...responsive}>
        <Button
          isResponsive
          isSubmitting={submitting}
          onPress={handleSubmit}
          isWidthOfContainer
          text={'Save'}
        />
      </Footer>
    </React.Fragment>
  );
};

NewProjectPageV2Fields.fragment = gql`
  ${JobFields.fragment}
  ${ProjectFieldsForJob.fragment}

  fragment NewProjectPageV2Fields on Organization {
    id
    ...JobFields
    ...ProjectFieldsForJob
  }
`;

export default NewProjectPageV2Fields;
